<template>
  <div class="b_w">
    <headTop head-title='出售记录' go-user="true">
    </headTop>
    <list :list="list" :type="2" :sta="sta" @scrollToEnd="scrollToEnd" @pulldown="pulldown" ref="list"></list>
    <!-- <pop :arr="arr"></pop> -->
  </div>
</template>

<script>
  import headTop from '@/components/common/header/head'
  import list from '@/components/record/list'
  // import pop from '@/components/record/pop'
  import { saleResource } from '@/resource/resource'
  const ERR_OK = 0
  export default {
    name: 'buylist',
    data () {
      return {
        list: [],
        total: 0,
        params: {
          count: 20,
          page: 0
        },
        sta: 0
      }
    },
    created () {
      this.getList(this.params)
    },
    mounted () {
    },
    methods: {
      getList(params, isRefresh = false) {
        saleResource.userlist(params).then(res => {
          res = res.body
          if (res.errcode === ERR_OK) {
            this.total = res.page
            if (isRefresh) {
              this.list = res.data
            } else {
              this.list = this.list.concat(res.data)
            }
          }
          this.$refs.list.finish()
          this.sta = this.list.length ? 0 : 1
        })
      },
      scrollToEnd () {
        this.params.page++
        if (this.params.page < this.total) {
          this.getList(this.params)
        } else {
          this.$toast('没有更多数据')
        }
      },
      pulldown () {
        // this.stopTouchendPropagationAfterScroll()
        this.params.page = 0
        this.getList(this.params, true)
      }
    },
    components: {
      list,
      headTop
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .b_w
    position relative
    .rt
      position absolute
      top 0
      right 0
      height 0.9rem
      line-height 0.9rem
      font-size $fz-t3
      color #fff
      padding-right 0.2rem
      z-index 101
</style>



// WEBPACK FOOTER //
// src/components/record/selllist.vue